import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { X, Zap } from 'lucide-react';

const API_URL = (process.env.REACT_APP_BACKEND_URL || '') + '/api';
const DISMISS_KEY = 'sk_exit_intent_dismissed';

export const ExitIntentPopup = () => {
  const navigate = useNavigate();
  const [enabled, setEnabled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    axios.get(`${API_URL}/growth/site-config`)
      .then((r) => setEnabled(!!r.data.exit_intent_enabled))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!enabled) return;
    let armed = true;
    const trigger = () => {
      if (!armed || localStorage.getItem(DISMISS_KEY)) return;
      armed = false;
      setOpen(true);
    };
    // Desktop: mouse leaves toward the top (closing/switching tab)
    const onLeave = (e) => { if (e.clientY <= 0) trigger(); };
    document.addEventListener('mouseout', onLeave);
    // Mobile fallback: fire after 25s of engagement
    const t = setTimeout(trigger, 25000);
    return () => { document.removeEventListener('mouseout', onLeave); clearTimeout(t); };
  }, [enabled]);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, '1'); setOpen(false); };
  const go = () => { localStorage.setItem(DISMISS_KEY, '1'); setOpen(false); navigate('/register?plan=pro&trial=1'); };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="exit-intent-popup">
      <div className="relative w-full max-w-md bg-[#0c1220] border border-emerald-500/30 rounded-3xl p-8 text-center shadow-2xl">
        <button onClick={dismiss} className="absolute top-4 right-4 text-zinc-500 hover:text-white" data-testid="exit-intent-close"><X className="w-5 h-5" /></button>
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-emerald-500/15 mb-4">
          <Zap className="w-7 h-7 text-emerald-400" />
        </div>
        <h2 className="text-2xl font-black text-white mb-2">Wait — grab 14 days free</h2>
        <p className="text-sm text-zinc-400 mb-6 leading-relaxed">Before you go: unlock every AI prediction, value pick and banker of the day. No charge for 14 days, cancel anytime.</p>
        <button onClick={go} data-testid="exit-intent-cta" className="w-full py-3.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold transition-colors">Start my 14-day free trial</button>
        <button onClick={dismiss} className="mt-3 text-xs text-zinc-500 hover:text-zinc-300" data-testid="exit-intent-dismiss">No thanks, maybe later</button>
      </div>
    </div>
  );
};
